export default {
      id: "reflective_2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#reflective_2",
      toString: function () {
        return this.url;
      }
    }